module.exports = __webpack_public_path__ + "assets/img/complaint_state_3.2f204bb2.svg";